import * as model from "@/model/adm/Chart";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.Chart(), newFilter)
    .withStates({
        idReport: 2,
        chartItemsLabel:[
            {key:'yAttribute',label:'lbl.chart.yAttribute'},
            {key:'yName',label:'lbl.chart.yName'},
           
        ],
    }) //TODO load at the application start
    .withMutations({
        addChartItem(state,object) {
            state.entity.chartItems.push(object);
        },
        deleteChartItem(state,index) {
            state.entity.chartItems.splice(index,1);
        }
    })
    .buildStore()
 
